// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__37hEc","container":"Footer_container__188QZ","copyright":"Footer_copyright__2wqDr"};